import { render, staticRenderFns } from "./ProductDetailHead.vue?vue&type=template&id=7c4561bf&scoped=true"
import script from "./ProductDetailHead.vue?vue&type=script&lang=js"
export * from "./ProductDetailHead.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailHead.vue?vue&type=style&index=0&id=7c4561bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4561bf",
  null
  
)

export default component.exports